import { Component, ViewChild, ElementRef, Input } from '@angular/core';

@Component({
  selector: 'app-color-input',
  templateUrl: `./color-input.component.html`,
  styleUrls: [`./color-input.component.css`]
})
export class ColorInputComponent {
  @ViewChild('enterColorString', {static: false})
  enterColorString: ElementRef;

  @Input()
  lineNumber: number;

  @Input()
  value: string;

  invalidColorString: boolean;

  onInput(){
    console.log(this.value);
  }

  onEnterColor() {
    this.invalidColorString = false;
    if (this.enterColorString && !this.value){
      this.value = '#';
    }
  }

  onSaveColor(colorValue: string) {
    const colorCodeValidator = /^#([A-Fa-f0-9]{6})$/;
    const invalidColorCode = !colorCodeValidator.test(colorValue) && colorValue.length && colorValue !== '#';
    this.invalidColorString = invalidColorCode;

    if (this.enterColorString && (invalidColorCode || colorValue === '#')) {
      this.value = '';
    }
  }
}
